import { Configuration } from "../api";
import { RunningTimesApi } from "../api/api";
import { useQuery } from "react-query";
import type { ResourceRunningTime } from "../api";

type Query = {
  from?: number;
  to?: number;
};

const useRunningTimes = (basePath: string, customerId: string, resourceId: string, query: Query = {}) => {
  const runningTimesApi = new RunningTimesApi(new Configuration({ basePath }));
  return useQuery<ResourceRunningTime[]>(["runningTimes", query.from, query.to], async () => {
    const res = await runningTimesApi.allResourcesRunningTimes(customerId, resourceId, query.from, query.to);
    return res.data;
  });
};

export default useRunningTimes;
